import { MemberService } from "@/services/member-service.js";
import { ProjectService } from "@/services/project-service.js";
import { CommonService } from "@/services/common-service.js";
import { checkError } from "@/config/errors.js";

export default {
  namespaced: true,

  state: {
    MemberList: [],
    error: null,
    loader: false,
    ClubMemberList: [],
    OfficeRoleMemberList: [],
    RegionClubsList: [],
    RoleClubsList: [],
    ServiceProjectMembers: [],
    zoneChairList: [],
    regionChairList: [],
    zoneList: [],
  },

  mutations: {
    setLoader(state, payload) {
      state.loader = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setClearError(state) {
      state.error = null;
    },
    clearMemberList(state) {
      state.MemberList = [];
    },
    setMemberList(state, payload) {
      state.MemberList = payload;
    },

    clearClubMemberList(state) {
      state.ClubMemberList = [];
    },
    setClubMemberList(state, payload) {
      state.ClubMemberList = payload;
    },

    clearOfficeRoleMemberList(state) {
      state.OfficeRoleMemberList = [];
    },
    setOfficeRoleMemberList(state, payload) {
      state.OfficeRoleMemberList = payload;
    },
   
    setServiceProjectMembers(state, payload){
      state.ServiceProjectMembers = payload;
    },    

    clearRegionClubsList(state) {
      state.RegionClubsList = [];
    },
    setRegionClubsList(state, payload) {
      state.RegionClubsList = payload;
    },

    setRoleClubsList(state, payload) {
      state.RoleClubsList = payload;
    },

    setZoneList(state, payload) {
      state.ZoneList = payload;
    },

    clearZoneChairList(state) {
      state.zoneChairList = [];
    },

    setZoneChairList(state, payload) {
      state.zoneChairList = payload;
    },

    clearRegionChairList(state) {
      state.regionChairList = [];
    },

    setRegionChairList(state, payload) {
      state.regionChairList = payload;
    },
  },

  actions: {
    getAllMembersBySearch({ commit }, search) {
      commit("setLoader", true);
      commit("setClearError");
      return new Promise((resolve) => {
        MemberService.getAllMembersBySearch(search)
          .then((response) => {
            commit("setMemberList", response.data.data);
            commit("setLoader", false);
            resolve(response);
          })
          .catch((error) => {
            commit("setMemberList", []);
            commit("setLoader", false);
            if (error.response.data.status_code === 404) {
              commit("setClearError");
            } else {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              commit("setError", errorOutput);
            }
          });
      });
    },

    getClubMembersBySearch({ commit }, data) {
      commit("setLoader", true);
      commit("setClearError");
      return new Promise((resolve) => {
        MemberService.getClubMembersBySearch(data)
          .then((response) => {
            commit("setClubMemberList", response.data.data);
            commit("setLoader", false);
            resolve(response);
          })
          .catch((error) => {
            commit("setClubMemberList", []);
            commit("setLoader", false);
            if (error.response.data.status_code === 404) {
              commit("setClearError");
            } else {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              commit("setError", errorOutput);
            }
          });
      });
    },

    getServiceProjectMembers({ commit }, data){
      commit("setLoader", true);
      commit("setClearError");
      return new Promise((resolve) => {
        MemberService.getServiceProjectMembers(data.uuid, data.search)
          .then((response) => {
            commit("setServiceProjectMembers", response.data.data);
            commit("setLoader", false);
            resolve(response);
          })
          .catch((error) => {
            commit("setServiceProjectMembers", []);
            commit("setLoader", false);
            if (error.response.data.status_code === 404) {
              commit("setClearError");
            } else {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              commit("setError", errorOutput);
            }
          });
      });
    },

    getMembersByOfficeRole({ commit }, data) {
      commit("setLoader", true);
      commit("setClearError");
      return new Promise((resolve) => {
        MemberService.getMembersByOfficeRole(data.search, data.uuid)
          .then((response) => {
            commit("setOfficeRoleMemberList", response.data.data);
            commit("setLoader", false);
            resolve(response);
          })
          .catch((error) => {
            commit("setOfficeRoleMemberList", []);
            commit("setLoader", false);
            if (error.response.data.status_code === 404) {
              commit("setClearError");
            } else {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              commit("setError", errorOutput);
            }
          });
      });
    },

    getProjectRegionClubs({ commit }, data) {
      commit("setLoader", true);
      commit("setClearError");
      return new Promise((resolve) => {
        ProjectService.getProjectRegionClubs(data.uuid, ''  )
          .then((response) => {
            commit("setRegionClubsList", response.data.data);
            commit("setLoader", false);
            resolve(response);
          })
          .catch((error) => {
            commit("setRegionClubsList", []);
            commit("setLoader", false);
            if (error.response.data.status_code === 404) {
              commit("setClearError");
            } else {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              commit("setError", errorOutput);
            }
          });
      });
    },

    getRoleClubs({ commit }, data) {
      commit("setLoader", true);
      commit("setClearError");
      return new Promise((resolve) => {
        CommonService.getUserRoleClubs(data)
          .then((response) => {
            commit("setRoleClubsList", response.data.data);
            commit("setLoader", false);
            resolve(response);
          })
          .catch((error) => {
            commit("setRoleClubsList", []);
            commit("setLoader", false);
            if (error.response.data.status_code === 404) {
              commit("setClearError");
            } else {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              commit("setError", errorOutput);
            }
          });
      });
    },

    getAllZones({ commit }) {
      commit("setLoader", true);
      commit("setClearError");
      return new Promise((resolve) => {
        CommonService.getAllZone()
          .then((response) => {
            commit("setZoneList", response.data.data);
            commit("setLoader", false);
            resolve(response);
          })
          .catch((error) => {
            commit("setZoneList", []);
            commit("setLoader", false);
            if (error.response.data.status_code === 404) {
              commit("setClearError");
            } else {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              commit("setError", errorOutput);
            }
          });
      });
    },

    getRegionChairManList({ commit }) {
      commit("setLoader", true);
      commit("setClearError");
      return new Promise((resolve) => {
        MemberService.getRegionChairManList()
          .then((response) => {
            commit("setRegionChairList", response.data.data);
            commit("setLoader", false);
            resolve(response);
          })
          .catch((error) => {
            commit("setRegionChairList", []);
            commit("setLoader", false);
            if (error.response.data.status_code === 404) {
              commit("setClearError");
            } else {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              commit("setError", errorOutput);
            }
          });
      });
    },

    getZoneChairManList({ commit }) {
      commit("setLoader", true);
      commit("setClearError");
      return new Promise((resolve) => {
        MemberService.getZoneChairManList()
          .then((response) => {
            commit("setZoneChairList", response.data.data);
            commit("setLoader", false);
            resolve(response);
          })
          .catch((error) => {
            commit("setZoneChairList", []);
            commit("setLoader", false);
            if (error.response.data.status_code === 404) {
              commit("setClearError");
            } else {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              commit("setError", errorOutput);
            }
          });
      });
    },

    clearError({ commit }) {
      commit("setClearError");
    },

    clearMemberList({ commit }) {
      commit("clearMemberList");
    },

    clearClubMemberList({ commit }) {
      commit("clearClubMemberList");
    },

    clearOfficeRoleMemberList({ commit }) {
      commit("clearOfficeMemberList");
    },

    clearServiceProjectMembers({ commit }) {
      commit("clearServiceProjectMembers");
    },    

    clearsRegionClubsList({ commit }) {
      commit("clearRegionClubsList");
    },

    clearsRoleClubsList({ commit }) {
      commit("clearRoleClubsList");
    },
    clearsZoneList({ commit }) {
      commit("clearZoneList");
    },
  },

  getters: {
    loading(state) {
      return state.loader;
    },
    errors(state) {
      return state.error;
    },
    setMemberList(state) {
      return state.MemberList;
    },

    setClubMemberList(state) {
      return state.ClubMemberList;
    },

    setOfficeRoleMemberList(state) {
      return state.OfficeMemberList;
    },

    setServiceProjectMembers(state){
      return state.ServiceProjectMembers;
    },

    setRegionClubsList(state) {
      return state.RegionClubsList;
    },

    setRoleClubsList(state) {
      return state.RoleClubsList;
    },

    setRegionChairList(state) {
      return state.regionChairList;
    },

    setZoneChairList(state) {
      return state.zoneChairList;
    },

    setZoneList(state) {
      return state.ZoneList;
    },
  },
};
